import { DateTime } from 'luxon';
import { AddTachoInstallerModel } from './AddTachoInstallerModel';
import { TachoReleaseType } from './TachoReleaseType';

export interface UpdateTachoInstallerModel extends AddTachoInstallerModel {
    tachoReleaseInformationId: string;
}

export const defaultUpdateTachoInstallerModel: UpdateTachoInstallerModel = {
    tachoReleaseInformationId: '',
    file: undefined,
    patchNotes: '',
    releaseDate: DateTime.fromISO(''),
    versionMajor: 0,
    versionMinor: 0,
    versionPatch: 0,
    releaseType: TachoReleaseType.FullInstaller,
    size: 0,
    MD5: '',
    SHA256: '',
    isBeta: true,
    variant: '',
};
